import { CityData, OfficeData } from '@/types';
import React, { useEffect, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';

interface GISProps {
  city?: CityData;
  office?: OfficeData;
  projectId?: string;
  onFeatureClick?: (data: { type: string; id: string | number; properties: any }) => void;
}

export const GIS: React.FC<GISProps> = ({ 
  city, 
  office,
  projectId, 
  onFeatureClick 
}) => {
  // Get token from Redux store
  const token = useSelector((state: RootState) => state.user.token);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  
  // Build URL with parameters
  const baseUrl = process.env.REACT_APP_GIS_URL;
  const url = new URL(baseUrl as string);
  
  // Add all props as URL parameters
  if (city) url.searchParams.append("city_id", city.id);
  if (office) url.searchParams.append("ao_id", office.id);
  if (projectId) url.searchParams.append("project_id", projectId);
  // Send token to iframe after it loads
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe || !token) return;

    const handleIframeLoad = () => {
      // Get the current environment
      const targetOrigin = process.env.NODE_ENV === 'development' 
        ? 'http://localhost:3001'  // development
        : 'https://gis.eplanner.co.il';  // production

      // Send the token to the iframe
      iframe.contentWindow?.postMessage(
        { 
          type: 'AUTH_TOKEN',
          payload: { token }
        }, 
        targetOrigin  // שימוש בכתובת ספציפית במקום '*'
      );
    };

    iframe.addEventListener('load', handleIframeLoad);
    return () => iframe.removeEventListener('load', handleIframeLoad);
  }, [token]);
  
  // Set up event listener for messages from the iframe
  const handleMessage = useCallback((event: MessageEvent) => {
    // Verify the origin in production
    // if (event.origin !== 'your-gis-frontend-origin') return;

    if (event.data && event.data.type) {
      if (event.data.type === 'GIS_FEATURE_CLICK') {
        // Call the onFeatureClick callback with the data
        if (onFeatureClick) {
          onFeatureClick(event.data.payload);
        }
        
      }
      else if (event.data.type === 'GIS_MAP_CLICK') {
      }
    }
  }, [onFeatureClick]);
  
  // Add and remove event listener
  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handleMessage]);
  
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <iframe 
        ref={iframeRef}
        src={url.toString()} 
        style={{ 
          width: '100%', 
          height: '100%', 
          border: 'none'
        }}
        title="GIS Map"
        allowFullScreen
      />
    </div>
  );
};

export default GIS;